<template>
  <div>
    <el-dialog
      title="Suministrar Evidencia"
      :visible.sync="viewEvidence"
      :append-to-body="true"
      width="36%"
    >
      <!--v-modal="false"-->
      <span
        >Al terminar una tarea se necesita proporcionar una evidencia del
        cumplimiento de la misma.<br />
        <strong
          >Favor colocar una captura de pantalla o un documento que compruebe la
          finalización de esta tarea.
        </strong>
      </span>

      <!-- FILE UPLOADER -->
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :action="uploadUrl"
        style="margin-left: 20%; margin-top: 20px"
        :v-show="fileEvidence"
        :drag="true"
        :auto-upload="false"
        :multiple="true"
        :file-list="fileList"
        :limit="1"
        :on-change="OnChangeFile"
        :on-exceed="handleExceed"
        :on-success="handleSuccess"
        :on-error="handleError"
      >
        <!--:on-progress="handleProgress"-->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip" style="margin-left: 50px">
          Solo archivos con un tamaño menor de 26MB
        </div>
      </el-upload>

      <!-- BOTON -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">Cancelar</el-button>
        <el-button
          type="primary"
          @click="saveDocument"
          v-loading="UploadLoading"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
//import { BASE_API_URL } from "@/const";
export default {
  name: "ContractsRenovationEvidenceUpload",
  props: {
    viewEvidence: {
      type: Boolean,
      default: false,
      required: true
    },
    EventData: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      //viewEvidenceDialog: false,
      uploadUrl: "",
      fileEvidence: false,
      fileList: [],
      UploadLoading: false
    };
  },
  mounted() {
    //console.log("mounted Node_Env: ",process.env.NODE_ENV);
    /*
    if (process.env.NODE_ENV !== "development") {
      this.uploadUrl = `${BASE_API_URL}/api/gallery/uploadanyFile`;
    } else {
      this.uploadUrl = `/api/gallery/uploadanyFile`;
    }
    */
    this.uploadUrl = `https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile`;
  },
  computed: {
    viewEvidenceDialog() {
      console.log("viewEvidenceDialog : ", this.viewEvidence);
      return this.viewEvidence;
    }
  },
  methods: {
    handleExceed() {
      this.$message({
        type: "error",
        message: "Solo se permite subir un solo archivo."
      });
    },
    handleSuccess(response, _file, _fileList) {
      _fileList;
      //console.log("parametros resposnse: ", response, _file, _fileList)
      const documentName = response;
      this.fileURL = documentName;
      this.$message({
        type: "success",
        message: "Archivo suministrado con éxito"
      });
      this.UploadLoading = false;
      //this.viewEvidenceDialog = false;
      this.viewEvidence = false;
      _fileList = [];
      //console.log("file in child: " + _file);
      this.$emit("OnDocumentSAved", _file, this.EventData);
    },
    handleError(err, file, fileList) {
      err, file, fileList;
      /*
       */
      this.UploadLoading = false;
      this.$message({
        type: "error",
        message: "Sucedió un error al intentar subir el archivo"
      });
    },
    onCancel() {
      this.fileList = [];
      this.fileURL = "";
      //this.viewEvidenceDialog = false
      this.viewEvidence = false;
      this.UploadLoading = false;
      this.$emit("OnUploadCancelation");
    },
    async saveDocument() {
      //console.log("fileList: ", this.fileList)
      if (this.fileList.length > 0) {
        this.UploadLoading = true;
        await this.$refs.uploadFile.submit();
      } else {
        this.$message({
          message: "Nescesita subministrar un archivo de evidencia",
          type: "warning"
        });
      }
    },
    OnChangeFile(file, fList) {
      file;
      //console.log("OnChangeFile : ", file, "\n fileList:", fList);
      this.fileList = fList;
    }
  }
};
</script>

<style scoped></style>
